import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {environment} from "../../../../environments/environment.development";
import {AreaChanged, EtapaSolicitudDetalle, EtapasProyectoTramite} from "../components/interfaces/formulario.interfaces";
let apiVucUrl = environment.apiVucUrl;
@Injectable({
    providedIn: 'root'
})

export class FormularioAService {
    constructor(private http: HttpClient) {
    }

    actualizarAreas(areaChanged: AreaChanged) {
        console.log(`actualizarAreas ->=${areaChanged}`);
        return this.http.put<AreaChanged>(apiVucUrl + `api/v1.0/solicitud/areas/update`, areaChanged, { observe: 'response' });
    }
    obtenerEtapasProyecto(idProyecto: string) {
        return this.http.get<EtapasProyectoTramite[]>(apiVucUrl + `api/v1.0/solicitud/etapas/proyecto/${idProyecto}` , {observe: 'response'});
    }
    obtenerSolicitudDetProyecto(idProyecto: string) {
        return this.http.get<EtapaSolicitudDetalle[]>(apiVucUrl + `api/v1.0/solicitud/etapas/solicitud-detalle/${idProyecto}`, {observe: 'response'});
    }
}
